export enum SupplierApiMessages {
  Supplier_UPDATED = 'Supplier Updated Successfully',
  Supplier_DELETED = 'Supplier Deleted',
}
